import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, FontSizeInPx, LineHeightInPx, Spacing } from "@snapchat/snap-design-system";

export const LensNameText = styled.h3`
    margin-bottom: ${Spacing["2XS"]}px;
    font-size: ${FontSizeInPx.LARGE}px;
`;

export const lensDetailsContainer = css`
    margin-left: ${FontSizeInPx.COMPACT}px;
    line-height: ${LineHeightInPx.REGULAR}px;
    color: ${Colors.Black.V100};
`;
